'use client';
import React from 'react';
import type { ButtonProps } from './Button';
import Button from './Button';
import { IconChevronLeft } from '@tabler/icons-react';

export type BackButtonProps = ButtonProps;

export default function BackButton(props: BackButtonProps) {
	const { children, className } = props;

	return (
		<Button {...props} className={`BackButton subtle page-back-button ${className ?? ''}`}>
			<IconChevronLeft />
			{children}
		</Button>
	);
}
